<template>
    <div>
        <div v-for="(postback,key) in postbacks" :key="key">
            <el-input v-model="postback[1]" placeholder="http://..." class="url" @change="setUrl"/>
            <el-button type="danger" @click="delUrl(key)">DEL</el-button>
        </div>
        <el-button type="success" @click="addUrl">Append Postback URL</el-button>
    </div>
</template>

<script>
export default {
	data() {
		return{
            postbacks:[],
            is_first:true
		}
	},
    props:['value'],
    watch: {
        value:function(urls_json) {
            // console.log(urls_json);
            if(this.is_first) {
                this.is_first = false;
                const urls_obj = JSON.parse(urls_json);
                if(urls_obj) {
                    for (const key in urls_obj.all) {
                        this.postbacks.push([key,urls_obj.all[key]]);
                    }
                }
            }
        }
    },
    methods: {
        addUrl: function() {
            this.postbacks.push(['','']);
        },
        delUrl: function(key) {
            this.postbacks.splice(key,1);
        },
        setUrl: function() {
            let url_obj = new Object;
            url_obj.all = [];
            for (const url of this.postbacks) {
                if(url[1]!=''){
                    url_obj.all.push(url[1])
                }
            }
            this.$emit('input',JSON.stringify(url_obj));
        }
    }
}
</script>

<style scoped>
.flag {
    width:13%;
}
.url {
    width:76%;
}
</style>

